import React from "react";
import { Label } from "components/bootstrap";
import { LICENSE_STATUS } from "license/constants";
const LicenseStatus = ({ status }) => {
  switch (status) {
    case LICENSE_STATUS.active:
      return /* @__PURE__ */ React.createElement(Label, { bsStyle: "success" }, LICENSE_STATUS.active);
    case LICENSE_STATUS.queued:
      return /* @__PURE__ */ React.createElement(Label, { bsStyle: "primary" }, LICENSE_STATUS.queued);
    case LICENSE_STATUS.expired:
      return /* @__PURE__ */ React.createElement(Label, { bsStyle: "warning" }, LICENSE_STATUS.expired);
    case LICENSE_STATUS.inactive:
      return /* @__PURE__ */ React.createElement(Label, { bsStyle: "default" }, LICENSE_STATUS.inactive);
    default:
      return null;
  }
};
export default LicenseStatus;
